import { render, staticRenderFns } from "./CursosMain.vue?vue&type=template&id=dbd80c54"
import script from "./CursosMain.vue?vue&type=script&lang=js"
export * from "./CursosMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports